import React from 'react';
import { Sheet } from '../../../../mobile/structural/sheet';
import { useBoardLinkContent } from './useBoardLinkContent';
import BoardLinkSearchBar from './BoardLinkSearchBar';
import BoardLinkListContent from './BoardLinkListContent';
import { BoardLinkSearchItem } from './boardLinkTypes';

type BoardLinkSheetContentProps = {
    onSelect: (item: BoardLinkSearchItem) => boolean;
    onPasteBoardLink: (text: string) => boolean;
};

const BoardLinkSheetContent: React.FC<BoardLinkSheetContentProps> = ({ onSelect, onPasteBoardLink }) => {
    const { searchQuery, setSearchQuery, ...listContentProps } = useBoardLinkContent();

    return (
        <div className="px-3.5">
            <BoardLinkSearchBar
                className="mb-2 pt-0"
                value={searchQuery ?? ''}
                onChange={setSearchQuery}
                onPasteBoardLink={onPasteBoardLink}
                autoFocus={true}
                size="lg"
            />
            <Sheet.Content className="px-0">
                <BoardLinkListContent onSelect={onSelect} size="lg" {...listContentProps} />
            </Sheet.Content>
        </div>
    );
};

export default BoardLinkSheetContent;
